const firebaseConfig = {
    apiKey: "AIzaSyDbErIR7MALl2uXPoxTvk8EpjwI_kIhPS0",
    authDomain: "go-wash-laundry.firebaseapp.com",
    projectId: "go-wash-laundry",
    storageBucket: "go-wash-laundry.appspot.com",
    messagingSenderId: "557606000847",
    appId: "1:557606000847:web:986a0dd8bf0e78d4f7bfba"
  };

export default firebaseConfig;